import { render } from "./Heart.vue?vue&type=template&id=21c6bbc2&scoped=true"
import script from "./Heart.vue?vue&type=script&lang=js"
export * from "./Heart.vue?vue&type=script&lang=js"

import "./Heart.vue?vue&type=style&index=0&id=21c6bbc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c6bbc2"]])

export default __exports__